import VenoBox from 'venobox'

export default function productLightbox() {
	new VenoBox({
		selector: '.venobox',
		numeration: true,
		infinigall: true,
		share: true,
		spinner: 'rotating-plane',
	})
}
